<style lang="less">

</style>
<template>
    <div>
        <Drawer :closable="false" placement="right" v-model="drawerVisible" width="50%" :title="drawerTitle">
            <Row>
                <Col>
                <Card :shadow="false">
                    <Row>
                        <Form ref="form" :model="form" :label-width="90" style="position:relative">
                            <FormItem label="证书编号" prop="certificateNum">
                                <Input v-model="form.certificateNum" style="width:600px"/>
                            </FormItem>
                            <FormItem label="颁发机构" prop="award">
                                <Input v-model="form.award" style="width:600px"/>
                            </FormItem>
                            <FormItem label="有效期" prop="validity">
                                <DatePicker :value="form.validity" type="date" format="yyyy-MM-dd" clearable @on-change="dataChange" placeholder="选择有效期" style="width: 200px"></DatePicker>
                            </FormItem>
                            <FormItem label="颁证时间" prop="awardTime">
                                <DatePicker :value="form.awardTime" type="date" format="yyyy-MM-dd" clearable @on-change="dataChange2" placeholder="选择颁证时间" style="width: 200px"></DatePicker>
                            </FormItem>
                            <FormItem label="身份证号" prop="idCard">
                                <Input :readonly="disabledSingle" v-model="form.idCard" style="width:600px"/>
                            </FormItem>
                            <Form-item class="br" >
                                <Button type="primary" :loading="submitLoading" @click="handelSubmit" style="width:80px">提交</Button>
                                <Button @click="handelCancel">取消</Button>
                            </Form-item>
                            <Spin size="large" fix v-if="loading"></Spin>
                        </Form>
                    </Row>
                </Card>
                </Col>
            </Row>
        </Drawer>
    </div>
</template>
<script>
    import {editUserCertificate} from "@/api/bus";
    import uploadInput from "@/views/my-components/flyme/upload-input";
    // 表情包配置 自定义表情可在该js文件中统一修改
    import {sina} from "@/libs/emoji";
    export default {
        name: "certificate-drawer",
        components: {
            uploadInput
        },
        data() {
            return {
                disabledSingle: false,
                picVisible: false,
                fileUrl: "",
                loading: false, // 表单加载状态
                drawerTitle: "证书修改",
                drawerVisible: false,
                form: {},
                submitLoading: false, // 添加或编辑提交状态
            };
        },
        methods: {
            showDrawer(params) {
                this.form = params;
                this.drawerVisible = true;
                if(params.userId){
                    this.disabledSingle = true
                }else{
                    this.disabledSingle = false
                }
            },
            handelSubmit() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        this.submitLoading = true;
                        // 编辑
                        editUserCertificate(this.form).then(res => {
                            this.submitLoading = false;
                            if (res.status === true) {
                                this.$Message.success("操作成功");
                                this.$parent.getDataList();
                                this.drawerVisible = false;
                            }
                        });
                    }
                });
            },
            dataChange(data1, data2) {
                this.form.validity = data1;
            },
            dataChange2(data1, data2) {
                this.form.awardTime = data1;
            },
            showPic(v) {
                this.fileUrl = v;
                this.picVisible = true;
            },
            handelCancel() {
                this.drawerVisible = false;
            }
        },
        mounted() {

        },
        watch: {

        }
    };
</script>